export const FacebookIcon = ({ ...props }) => (
   <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <g clip-path="url(#clip0_175_700)">
         <path
            d="M7 0.5C3.41018 0.5 0.5 3.41018 0.5 7C0.5 10.0482 2.59872 12.6061 5.42986 13.3086V8.9864H4.08956V7H5.42986V6.14408C5.42986 3.93174 6.43112 2.9063 8.60316 2.9063C9.015 2.9063 9.72558 2.98716 10.0163 3.06776V4.86826C9.86286 4.85214 9.59636 4.84408 9.26538 4.84408C8.19964 4.84408 7.7878 5.24786 7.7878 6.29748V7H9.91096L9.54618 8.9864H7.7878V13.4524C11.0063 13.0637 13.5003 10.3233 13.5003 7C13.5 3.41018 10.5898 0.5 7 0.5Z"
            fill="#1E3455"
         />
      </g>
      <defs>
         <clipPath id="clip0_175_700">
            <rect
               width="13"
               height="13"
               fill="white"
               transform="translate(0.5 0.5)"
            />
         </clipPath>
      </defs>
   </svg>
);
